export const fedexPackagingOptions = [
  { value: "YOUR_PACKAGING", label: "Your Packaging", maxWeight: 0 },
  { value: "FEDEX_ENVELOPE", label: "FedEx Envelope", maxWeight: 0.5 },
  { value: "FEDEX_PAK", label: "FedEx Pak", maxWeight: 9 },
];

export const SHIPMENT_PURPOSES = [
  { value: "Commercial", label: "Commercial" },
  { value: "Gift", label: "Gift" },
  { value: "Sample", label: "Sample" },
  { value: "Repair and return", label: "Repair and return" },
  { value: "Personal effects", label: "Personal effects" },
  { value: "Personal use", label: "Personal use" },
];

export const normalizeProviderCode = (provider?: string | null) =>
  provider ? provider.toLowerCase().replace(/\s+/g, "") : null;

export const isFedexProvider = (
  provider?: string | null,
  providerCode?: string | null
) => normalizeProviderCode(providerCode || provider) === "fedex";
